import { httpClient2 } from "modules/core/utils/httpClient2";

import { UserRole } from "../types/entities";

export const completeOnboarding = async ({
  user_role
}: {
  user_role: UserRole;
}) => {
  const res = await httpClient2.post("/onboarding/complete", { user_role });

  return res.data;
};
